const isPortalHost = hostname => {
  return /^www\.([^.]+)\.svenskaspelportal\.se$/.test(hostname) || hostname === 'www.svenskaspelportal.se';
};
const getIamLoginBaseUrl = () => {
  return '';
};
const isLocalHost = hostname => {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('local.') || hostname.includes('.local.');
};
export const getPortalBaseUrlForHostname = hostname => {
  const hostKey = String(hostname || '').toLowerCase();
  if (!hostKey) {
    return '';
  }
  if (isLocalHost(hostKey)) {
    return 'https://local.www.test3.svenskaspelportal.se';
  }
  if (hostKey.includes('test3')) {
    return 'https://www.test3.svenskaspelportal.se';
  }
  if (hostKey.includes('test')) {
    return 'https://www.test.svenskaspelportal.se';
  }
  if (hostKey === 'ombudslogin.svenskaspel.se' || hostKey === 'www.svenskaspelportal.se') {
    return 'https://www.svenskaspelportal.se';
  }
  return '';
};
export const getPortalBaseUrlForCurrentHost = () => {
  if (typeof window === 'undefined') {
    return 'https://www.svenskaspelportal.se';
  }
  return getPortalBaseUrlForHostname(window.location.hostname) || window.location.origin;
};
export const shouldUseIamFlowForCurrentHost = (isIamFeatureEnabled = false) => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (!isIamFeatureEnabled) {
    return false;
  }
  const {
    hostname
  } = window.location;
  if (isLocalHost(hostname)) {
    return true;
  }
  if (hostname.includes('ombudslogin.')) {
    return true;
  }
  return isPortalHost(hostname);
};
export const getIamLoginUrl = path => `${getIamLoginBaseUrl()}${path}`;